module.exports = __webpack_public_path__ + "img/-e-js_banner.080173fa.png";